// src/DataNode.tsx
var CH_SPLIT = ".";
function find(parent, name) {
  if (!parent || !parent.nodes) return null;
  for (const node of parent.nodes) {
    if (node.name.toLowerCase() === name.toLowerCase()) {
      return node;
    }
  }
  return null;
}
function path(root, pathStr) {
  if (!root) return null;
  let elem = root;
  const fields = pathStr.split(CH_SPLIT);
  for (const field of fields) {
    if (!elem) break;
    elem = find(elem, field);
  }
  return elem;
}
function findValue(element, key) {
  if (!element || !element.values) return null;
  for (const val of element.values) {
    if (val.key.toLowerCase() === key.toLowerCase()) {
      return val.value;
    }
  }
  return null;
}

// src/ViewNode.tsx
var NN_FORM = "form";
var NN_FRAME = "frame";
var NN_MENU = "menu";
var NN_MESSAGE = "message";
function findMessage(root, app, lang, key) {
  if (!root) return null;
  const pathStr = `${pathCollection(NN_MESSAGE, app)}.${lang}.message_collection.${key}`;
  const node = path(root, pathStr);
  if (node) {
    return findValue(node, "value") || findValue(node, "LABEL");
  }
  return null;
}
function findMenu(root, app, key) {
  return findCollection(root, app, NN_MENU, key);
}
function findFrame(root, app, key) {
  return findCollection(root, app, NN_FRAME, key);
}
function findForm(root, app, key) {
  return findCollection(root, app, NN_FORM, key);
}
function findCollection(root, app, type, key) {
  if (!root) return null;
  const pathStr = `${pathCollection(type, app)}.${key}`;
  return path(root, pathStr);
}
function pathCollection(type, app) {
  if (!type || !app) return null;
  return `view_root.view_collection.${app}.${type}_collection`;
}
export {
  find,
  findCollection,
  findForm,
  findFrame,
  findMenu,
  findMessage,
  findValue,
  path,
  pathCollection
};
